import { ChangeEvent } from "react";

type TMask = ((event: ChangeEvent<HTMLInputElement>) => string) & {
    unMask: (maskedValue: string) => string;
};

export function NormalizeTelephone(tel: string) {
    const [, ddi, ddd, number] =
        tel.replace(/\D/g, "").split(/(\d{0,2})(\d{0,2})(\d{0,9})/) || [];
    const [, number1, number2] = number?.split(/(\d{4,5})(\d{4})/) || [];

    let normalized = "";
    if (ddi?.length === 2) normalized += `+${ddi}`;
    else if (ddi?.length > 0) normalized += `${ddi}`;
    if (ddd?.length === 2 && number?.length > 0) normalized += ` (${ddd})`;
    else if (ddd?.length > 0) normalized += ` ${ddd}`;
    if (number2?.length > 0) normalized += ` ${number1}-${number2}`;
    else if (number?.length > 0) normalized += ` ${number}`;

    return normalized;
}
export function FormatterCEP(str: string) {
    var re = /^([\d]{2})\.?([\d]{3})-?([\d]{3})/;

    if (re.test(str)) {
        return str.replace(re, "$1.$2-$3");
    }
    return "";
}
export function FormatterRG(v0: string, errChar = "?") {
    const v = v0.toUpperCase().replace(/[^\dX]/g, "");
    return v.length === 8 || v.length === 9
        ? v.replace(/^(\d{1,2})(\d{3})(\d{3})([\dX])$/, "$1.$2.$3-$4")
        : errChar + v0;
}
export function FormatterCPF(CPF_CNPJ: string) {
    //retira os caracteres indesejados...
    CPF_CNPJ = CPF_CNPJ.replace(/[^\d]/g, "");

    if (CPF_CNPJ.length > 11) {
        return CPF_CNPJ.replace(
            /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
            "$1.$2.$3/$4-$5"
        );
    } else {
        return CPF_CNPJ.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }
}

export function formatterCPF_CNPJ(event: ChangeEvent<HTMLInputElement>) {
    const value = event.target.value.replaceAll(/[^\d,]/g, ""); //Remove tudo o que não é dígito
    let newValue = value;
    if (event.target.value.length <= 14) {
        newValue = newValue.replace(/(\d{3})(\d)/, "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
        newValue = newValue.replace(/(\d{3})(\d)/, "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
        //de novo (para o segundo bloco de números)
        newValue = newValue.replace(/(\d{3})(\d{1,2})$/, "$1-$2"); //Coloca um hífen entre o terceiro e o quarto dígitos
    } else {
        newValue = newValue.replace(/\D/g, ""); //Remove tudo o que não é dígito
        newValue = newValue.replace(/^(\d{2})(\d)/, "$1.$2"); //Coloca ponto entre o segundo e o terceiro dígitos
        newValue = newValue.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3"); //Coloca ponto entre o quinto e o sexto dígitos
        newValue = newValue.replace(/\.(\d{3})(\d)/, ".$1/$2"); //Coloca uma barra entre o oitavo e o nono dígitos
        newValue = newValue.replace(/(\d{4})(\d)/, "$1-$2"); //Coloca um hífen depois do bloco de quatro dígitos
    }

    event.target.value = newValue;

    return event.target.value;
}

export function formatterContratoCEF(event: ChangeEvent<HTMLInputElement>) {
    const value = event.target.value.replaceAll(/[^\d,]/g, ""); //Remove tudo o que não é dígito
    let newValue = value;

    newValue = newValue.replace(/(\d{1})(\d)/, "$1.$2"); //Coloca um ponto entre o primeiro e o segundo dígito
    newValue = newValue.replace(/(\d{4})(\d)/, "$1.$2"); //Coloca um ponto entre o quarto e o quinto dígito
    newValue = newValue.replace(/(\d{7})(\d{1,2})$/, "$1-$2"); //Coloca um hífen entre o quinto e o sexto dígitos

    event.target.value = newValue;

    return event.target.value;
}

export function FormatterTelefone(event: ChangeEvent<HTMLInputElement>) {
    const value = event.target.value.replaceAll(/[^\d]/g, ""); // Remove tudo o que não é dígito
    let newValue = value;

    newValue = newValue.replace(/^(\d{2})(\d)/, "($1) $2"); // Coloca parênteses entre o DDD e o número
    newValue = newValue.replace(/(\d{4,5})(\d)/, "$1-$2"); // Coloca hífen entre os números

    event.target.value = newValue;

    return event.target.value;
}

export function FormatadorParaRG(event: ChangeEvent<HTMLInputElement>) {
    const value = event.target.value.toUpperCase().replace(/[^\dX]/g, ""); // Remove caracteres não numéricos, mantendo o X maiúsculo

    let formattedValue = value;
    const length = value.length;

    if (length > 2 && length <= 6) {
        formattedValue = value.replace(/^(\d{1,2})(\d{0,3})$/, "$1.$2"); // Adiciona ponto após os primeiros 2 dígitos
    } else if (length > 6) {
        formattedValue = value.replace(
            /^(\d{1,2})(\d{0,3})(\d{0,3})([\dX])$/,
            "$1.$2.$3-$4"
        ); // Adiciona ponto e hífen conforme o padrão de RG com 8 ou 9 dígitos
    }

    event.target.value = formattedValue;

    return formattedValue;
}

export function FormatadorParaCEP(event: ChangeEvent<HTMLInputElement>) {
    const value = event.target.value.replace(/\D/g, ""); // Remove caracteres não numéricos

    let formattedValue = value;
    const length = value.length;

    if (length > 2) {
        formattedValue = value.replace(/^(\d{2})(\d{0,3})$/, "$1.$2"); // Adiciona o ponto após os primeiros 2 dígitos
    }

    if (length > 5) {
        formattedValue = value.replace(/^(\d{2})(\d{3})(\d{0,3})$/, "$1.$2-$3"); // Adiciona o hífen após os primeiros 5 dígitos
    }

    event.target.value = formattedValue;

    return formattedValue;
}

const MoneyReaisFieldMask = ((event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.replaceAll(/[^\d,]/g, "");

    let newValue = value;
    if (value) {
        let [reais, centavos] = value.split(",");
        if (!centavos || centavos.length === 0) {
            centavos = reais;
            reais = "0";
        } else if (centavos.length === 1) {
            centavos = `${reais.charAt(reais.length - 1)}${centavos}`;
            reais = reais.substring(0, reais.length - 1) ?? "0";
        } else if (centavos.length > 2) {
            reais =
                (reais !== "0" ? reais : "") +
                centavos.substring(0, centavos.length - 2);
            centavos = centavos.substring(centavos.length - 2);
        }
        let resto = reais;
        let stringFinal = "";

        while (resto.length > 3) {
            const novoResto = resto.substring(0, resto.length - 3);
            const tresUltimos = resto.substring(resto.length - 3, resto.length);
            stringFinal = "." + tresUltimos + stringFinal;
            resto = novoResto;
        }
        reais = resto + stringFinal;

        if (
            (centavos === "0" || centavos === "00") &&
            (reais === "0" || reais === "")
        )
            newValue = "R$0,00";
        else newValue = `R$${reais || "0"},${centavos}`;
    }

    event.target.value = newValue;

    return event.target.value;
}) as TMask;
MoneyReaisFieldMask.unMask = (masked) =>
    masked.replaceAll(/[^\d,]/g, "").replace(",", ".");

export { MoneyReaisFieldMask };
